import { Box, Button, Divider, Stack } from '@mui/material';

interface SubCategoryButtonProps {
  activeFilters: any;
  selected: boolean;
  label: string;
  separator?: boolean;
  onClick: () => void;
}

export const SubCategoryButton = ({
  label,
  selected,
  separator,
  onClick
}: SubCategoryButtonProps) => {
  return (
    <Box
      sx={{
        mb: 2
      }}
    >
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center'
        }}
      >
        <Button
          onClick={onClick}
          size="small"
          sx={{ whiteSpace: 'nowrap' }}
          variant={selected ? 'contained' : 'outlined'}
        >
          {label}
        </Button>
        {separator && (
          <Divider orientation="vertical" flexItem sx={{ ml: 2, width: 2 }} />
        )}
      </Stack>
    </Box>
  );
};
